export const getAppVersion = (
  () => () =>
    process.env.REACT_APP_BUILD_VERSION
)();